export const getTimeFormated = (hours: number | null, minutes: number, seconds: number) => {
    if (seconds == null) {
        return '00:00'
    }

    let timeStr = ''

    if (hours && Math.floor(hours) > 0) {
        timeStr += String(Math.floor(hours)).padStart(2, '0')
        timeStr += ':'
    }

    timeStr += String(Math.floor(minutes)).padStart(2, '0')
    timeStr += ':'
    timeStr += String(Math.floor(seconds)).padStart(2, '0')

    return timeStr
}